import React from 'react'
import { monthNumToTxtSmall, toDayMonthYear } from '../../Helper/calculations'
import styles from '../Users/EachVisitWrapper.module.css'
import { Link } from 'react-router-dom'
import { MdCalendarToday, MdArrowForward } from 'react-icons/md'

const EachVisitWrapper = props => {
    const item = props.item
    const [dd, mm, yyyy] = toDayMonthYear(item.payStatusLastUpdatedAt)

    return (
        <div className={styles.mainWrapper}>
            <div className={styles.dateBlock}>
                <MdCalendarToday size={13} className={styles.dateIcon} />
                <span className={styles.dateText}>{dd} {monthNumToTxtSmall(mm)}'{yyyy}</span>
            </div>
            <div className={styles.amount}>
                &#8377;{item.amountToBeCollected}/-
            </div>
            <Link to={"/booking/" + item.bookingId} className={styles.goBtn}>
                Go <MdArrowForward size={14} />
            </Link>
        </div>
    )
}

export default EachVisitWrapper
